// removed by extract-text-webpack-plugin
module.exports = {"modal":"MobileQuestionDefinitionView__modal___dYwgv"};